export type BillingInterval = 'ANNUAL' | 'MONTHLY';
export type PreselectedPlan = { plan: 'MEMBER' | 'PRO' | 'TEAM'; interval: BillingInterval };
export type OpenBillingModalOptions = { interval?: BillingInterval; plan?: PreselectedPlan | null };

// The pricing popup opens on Monthly unless the caller asks for a plan or an interval.
export const DEFAULT_BILLING_INTERVAL: BillingInterval = 'MONTHLY';

export const resolveOpenInterval = (opts?: OpenBillingModalOptions): BillingInterval =>
  opts?.plan?.interval ?? opts?.interval ?? DEFAULT_BILLING_INTERVAL;
